<template>
  <div>
    <el-dialog
      ref="viewDialog"
      v-dialogDrag
      title="查看零售户成长值核销信息"
      :visible.sync="dialogVisible"
      :class="{'abow_dialog': true, 'h380_dialog': dialogViewForm.offsetResult !== 2, 'h430_dialog': dialogViewForm.offsetResult === 2}"
      width="1100px"
      :before-close="modalClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
    >
      <el-form
        ref="dialogViewForm"
        :model="dialogViewForm"
        class="add-edit-view-form"
        @submit.native.prevent
      >
        <div class="modal-box">
          <h3 class="modal-title">
            零售户成长值核销(兑换)信息
          </h3>
          <div class="modal-row-box">
            <el-row :gutter="10">
              <el-col :span="6">
                <el-form-item label="省区">
                  <el-input
                    v-model="dialogViewForm.provinceName"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="18">
                <el-form-item label="名称">
                  <el-input
                    v-model="dialogViewForm.name"
                    disabled
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="6">
                <el-form-item label="账号">
                  <el-input
                    v-model="dialogViewForm.account"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="18">
                <el-form-item label="账号类型">
                  <el-radio-group
                    v-model="dialogViewForm.accountType"
                    disabled
                  >
                    <el-radio :label="1">
                      睿零售用户电话
                    </el-radio>
                    <el-radio :label="2">
                      群成员微信号
                    </el-radio>
                    <el-radio :label="3">
                      调研问卷用户ID
                    </el-radio>
                    <el-radio :label="4">
                      专卖证号
                    </el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="6">
                <el-form-item label="核销成长值">
                  <el-input
                    v-model="dialogViewForm.growthValue"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="成长值核销结果">
                  <el-input
                    v-model="dialogViewForm.offsetResultValue"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="执行成长值核销时间">
                  <el-input
                    v-model="dialogViewForm.offsetGrowthValueTime"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col
                v-if="dialogViewForm.offsetResult === 2"
                :span="24"
              >
                <el-form-item label="核销失败原因">
                  <el-input
                    v-model="dialogViewForm.failReason"
                    disabled
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-form>

      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="modalClose">
          关闭
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// dialog拖拽Mixin
import dialogDragMixin from '@/mixin/dialogDragMixin'
// 成长值核销明细API
import { viewGrowthValueOffsetDetailApi } from '@/api/v2/growthValueOffsetDetail'

export default {
  components: {},
  mixins: [dialogDragMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dataId: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      dialogViewForm: {},
    }
  },
  watch: {
    dialogVisible (val) {
      if (val) {
        let _this = this;

        _this.dialogViewForm = {}
        _this.loadGrowthValueOffsetDetailData()

        _this.$nextTick(() => {
          _this.$refs.dialogViewForm.clearValidate()
        })
      }
    }
  },
  methods: {
    // 加载数据
    loadGrowthValueOffsetDetailData () {
      let _this = this;
      viewGrowthValueOffsetDetailApi({ id: _this.dataId }).then((response) => {
        const { data } = response;
        _this.dialogViewForm = data;

      })
    },
    modalClose () {
      let _this = this;
      _this.$emit('update:dialogVisible', false)
    },
  }
}
</script>
<style lang="scss"  scoped>
</style>
